import { industryList } from "./tokens";
export var getIndustryName = function (index) { return industryList[index - 1].label; };
export var fixToTwoDecimalPlaces = function (x) {
    return Math.round((x + Number.EPSILON) * 100) / 100;
};
export var fixToOneDecimalPlace = function (x) {
    return Math.round((x + Number.EPSILON) * 10) / 10;
};
